import React, { Component } from 'react';
import './ConfirmData.css';
import Navbar from '../Components/Navbar/Navbar'
import logoblue from '../../../image/logoblue.png'
import { Link } from 'react-router-dom';
import { LinkAPI } from '../../../API/API'
import axios from 'axios'
import HandleRes from '../Components/HandleRes/HandleRes';


class Resetpassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      passwordError: ""
    }
  }
  handleChange = event => {
    const isCheckbox = event.target.type === "checkbox";
    this.setState({
      [event.target.name]: isCheckbox
        ? event.target.checked
        : event.target.value
    });
  };

  validate = () => {
    let passwordError = "";
    // let passwordError = "";

    if (this.state.password.length < 8) {
      passwordError = "write your password correct";
    }

    if (passwordError) {
      this.setState({ passwordError });
      return false;
    }

    return true;
  };
  handleSubmit = event => {
    event.preventDefault();
    const { password } = this.state
    const Token = this.props.match.params.Token 
    const isValid = this.validate();
    if (isValid) {
      axios.put(`${LinkAPI}/api/businessowner/resetpassword`,{
        password:password
      } , {
        headers: {
            Authorization: `${Token}`,
            lang:"ar"
        }
    }
      ).then(res =>{        
        localStorage.setItem("userToken",res.data.token)
        localStorage.setItem("KaynuserName", res.data.businessOwner.name)
        window.location.replace("/AR/orders");
        }).catch(error=>{
        if (!error.response) {
          this.setState({
            networkError: true
          })
        } else if (error.response.data.message) {
          this.setState({
            emailError: "",
            passwordError: "",
            errordatamessage: true,
            errordatamessagetext: error.response.data.message
          })
        } else {
          this.setState({
            hasError: true,
          })
        }
        })
    }
  };
  render() {
    document.title ="kayn | اعادة كلمة السر ";
      document.getElementsByTagName("META")[1].content="كاين | اعادة كلمة السر   ";
      document.documentElement.lang = 'ar';
    return (
      <div className="AppAR signin">
        <Navbar />
        <div className='container'>
          <div className="Sign row my-0 " >
            
            <div className="col-md-6 form float-md-right  ">
              <div className="contantform text-center p-4 mt-150">
                <h3 className="fontsize1 my-4 py-3">ادخل كلمة سر جديده</h3>
                <form className="px-lg-5" onSubmit={this.handleSubmit}>
                 <div className="form-group mt-4 mb-1  py-3">
                    <input type="password" className={"form-control badge-pill p-3 noborder " + (this.state.passwordError ? 'is-invalid' : '')} placeholder=" كلمة السر" name="password" value={this.state.password}
                      onChange={this.handleChange} required />
                    <div style={{ fontSize: 12, color: "red" }}>
                      {this.state.passwordError}
                    </div>

                  </div>
                  {(this.state.errordatamessage ?
                    <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                        {this.state.errordatamessagetext}
                    </div> : '')}
                  <button type="submit" className="btn btn-primary badge-pill btn-block shadow p-2  mt-2"  >ارسال</button>
                </form>

              </div>
            </div>
            <div className=" logoform col-6 d-flex align-content-end flex-wrap ">
              <div className="col-12 text-center mt-auto p-2 bd-highlight"><Link to="/AR/"><img className="logo" src={logoblue} alt="kayn" /></Link>       </div>
              <p className="fontsize2 text-center mb-5 col-12">طلبك الخاصة بك ... طريقك</p>
            </div>
          </div>
        </div>
        {(this.state.res_sendcodedone ? <HandleRes title={this.state.resdonemessage} stylecss="alert-success" /> : '')}
        {(this.state.networkError ? <HandleRes title="تاكد باتصالك بالانترنت ثم عاود المحاوله" stylecss="alert-danger" /> : '')}
        {(this.state.hasError ? <HandleRes title="  هناك مشكلة في طلبك" stylecss="alert-danger" /> : '')}

      </div>
    )
  }
}
export default Resetpassword;